module.exports = __webpack_public_path__ + "static/media/3.514f75a5.jpg";